import React from "react";
import styles from "./pickerPromo.module.scss";
import { useContent } from "contexts/contentContext/contentContext";
import useMediaQueries from "hooks/useMediaQueries";

interface PromoIconTextProps {
  text: string;
}

const PromoIconText: React.FC<PromoIconTextProps> = ({ text }) => {
  const { getLanguage } = useContent();
  const { mobileCondition } = useMediaQueries();

  const isRtl = ["he", "ar"].includes(getLanguage());

  const characters = isRtl ? text.split("").reverse() : text.split("");

  // Calculate the angle distribution for each character
  // We want to go from 260 through 210, 180, 120 to 100 (counterclockwise)
  const angleStep = mobileCondition ? 16 : isRtl ? 14 : 10;

  const startAngle = 90 + (characters.length / 2) * angleStep;

  return (
    <div className={styles.circularText}>
      {characters.map((char, index) => {
        // Calculate the angle for this character - decrement to go counterclockwise
        const angle = startAngle - index * angleStep;
        // Handle angle wraparound from 0 to 360 degrees
        const normalizedAngle = angle < 0 ? angle + 360 : angle;
        const angleInRad = (normalizedAngle * Math.PI) / 180;

        // Calculate position on the circle
        const radius = mobileCondition ? 24 : isRtl ? 36 : 38; // Adjusted radius to match the circle size
        const x = radius * Math.cos(angleInRad);
        const y = radius * Math.sin(angleInRad);

        // Calculate rotation for this character (90 degrees offset to make text point outward)
        const rotation = normalizedAngle + 90;

        return (
          <div
            key={index}
            className={`${styles.circularChar} ${
              isRtl && !mobileCondition ? styles.rtl : ""
            }`}
            style={{
              transform: `translate(${x}px, ${y}px) rotate(${rotation}deg) scale(-1)`,
            }}
          >
            {char}
          </div>
        );
      })}
    </div>
  );
};

export default PromoIconText;
